import { Component } from 'react';
import styled from 'styled-components';
import LayoutCollectionView from './LayoutCollectionView';
import Dropdown from './Dropdown';

const ShopsSectionWrapper = styled.section`
  padding: ${({ theme }) => theme.unit(6)} 0 ${({ theme }) => theme.unit(6)};
`;

const SortingDropdownWrapper = styled.div`
  display: flex;
  justify-content: flex-end;

  padding: 24px 0 28px;
`;

const getSortedShops = ({
  shops,
  sortingConfig,
  selectedSortingOption,
}) => {
  const config = sortingConfig[selectedSortingOption];

  return config.getSortedArray(shops);
};

class LayoutSortableCollectionView extends Component {
  constructor(props) {
    super(props);
    const initialSortingOption = 'featured-first';

    this.state = {
      selectedSortingOption: initialSortingOption,
    };

    this.setSelectedSortingOption = this.setSelectedSortingOption.bind(this);
  }

  setSelectedSortingOption(newSortingOption) {
    const {
      selectedSortingOption,
    } = this.state;

    if (newSortingOption === selectedSortingOption) {
      return;
    }

    this.setState((prevState) => ({
      ...prevState,
      selectedSortingOption: newSortingOption,
    }));
  }

  render() {
    const {
      items,
      sortingConfig,
      sortingLabel,
      ...layoutCollectionViewProps
    } = this.props;

    const {
      selectedSortingOption,
    } = this.state;

    const sortedShops = getSortedShops({
      sortingConfig,
      shops: items,
      selectedSortingOption,
    });

    const sortingOptions = Object.entries(sortingConfig)
      .map(([soringOption, config]) => ({
        label: config.label,
        value: soringOption,
      }));

    return (
      <ShopsSectionWrapper>
        <LayoutCollectionView
          {...layoutCollectionViewProps}
          items={sortedShops}
          renderViewController={() => (
            <SortingDropdownWrapper>
              <Dropdown
                label={sortingLabel}
                options={sortingOptions}
                selectedOption={selectedSortingOption}
                onSelect={this.setSelectedSortingOption}
              />
            </SortingDropdownWrapper>
          )}
        />
      </ShopsSectionWrapper>
    );
  }
}

export default LayoutSortableCollectionView;
